import React from "react";
import Helper from "../functions/Helper.js";
import AdditionalInfo from "./AdditionalInfo.js";
//import CriticInfo from "./CriticInfo.js";
import { Link } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import queryString from "query-string";

const StyleRatingBox = {
  textAlign: "center",
  borderRadius: 2,
  width: 60,
  height: 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "bold",
  color: "white",
};

export default class QuoteBox extends React.Component {
  getLinks() {
    if (this.props.type === "blog") {
      return (
        <a
          onClick={() => {
            Helper.gaEvent("reviews", "Blog", this.props.blog_url);
          }}
          rel="noopener noreferrer"
          target="_blank"
          style={{
            fontSize: 16,
            color: "var(--grey-700)",
            fontWeight: "bold",
            lineHeight: 1.2,
          }}
          href={this.props.blog_url}
        >
          Read the article
        </a>
      );
    } else if (this.props.type === "video") {
      return (
        <span
          onClick={() => {
            Helper.gaEvent("reviews", "Video", this.props.video_url);
            this.props.showYoutube(
              Helper.getVideoID(this.props.video_url, "videoID")
            );
          }}
          style={{
            color: "var(--grey-700)",
            cursor: "pointer",
            fontSize: 16,
            fontWeight: "bold",
            lineHeight: 1.2,
          }}
        >
          <i
            style={{ color: "#ff0000", marginRight: 5 }}
            className="fab fa-lg fa-youtube"
          />
          Watch the video
        </span>
      );
    } else if (this.props.type === "both") {
      return (
        <span>
          <span>
            <span
              onClick={() => {
                this.props.showYoutube(
                  Helper.getVideoID(this.props.video_url, "videoID")
                );
              }}
              style={{
                fontSize: 16,
                color: "var(--grey-700)",
                cursor: "pointer",
                fontWeight: "bold",
                lineHeight: 1.2,
              }}
            >
              <i
                style={{ color: "#ff0000", marginRight: 5 }}
                className="fab fa-lg fa-youtube"
              />
              Watch the Video
            </span>
            <span
              style={{
                color: "var(--grey-700)",
                fontWeight: "bold",
                paddingLeft: 10,
                paddingRight: 10,
              }}
            >
              |
            </span>
          </span>
          <a
            rel="noopener noreferrer"
            target="_blank"
            style={{
              fontSize: 16,
              color: "var(--grey-700)",
              fontWeight: "bold",
              lineHeight: 1.2,
            }}
            href={this.props.blog_url}
          >
            Read the article
          </a>
        </span>
      );
    }
  }

  getRatingText(rating) {
    if (this.props.category === "outdoor") {
      return (
        <div
          style={{
            ...StyleRatingBox,
            fontSize: 16,
            backgroundColor: Helper.get_color(rating, "outdoor"),
          }}
        >
          {Helper.getOutdoorDescription(rating)}
        </div>
      );
    }

    if (this.props.category === "size" || this.props.category === "width") {
      return (
        <div
          style={{
            ...StyleRatingBox,
            lineHeight: "14px",
            fontSize: 12,
            backgroundColor: "grey",
          }}
        >
          {Helper.getSizeDescription(rating, this.props.category, "short")}
        </div>
      );
    } else {
      return (
        <div
          style={{
            ...StyleRatingBox,
            fontSize: 20,
            backgroundColor: Helper.get_color(rating),
          }}
        >
          {Helper.roundto(rating, 1)}
        </div>
      );
    }
  }

  render() {
    let rating =
      this.props.category === "overall"
        ? this.props.rating
        : this.props[this.props.category];
    let summary =
      this.props?.by === "user"
        ? this.props.summary
        : this.props[this.props.category + "_quote"];
    if (rating != -1) {
      return (
        <div style={{ marginBottom: 60, marginTop: 30, maxWidth: 600 }}>
          <div style={{ marginBottom: 15, display: "flex" }}>
            <OverlayTrigger
              popperConfig={{
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [-5, 10],
                    },
                  },
                ],
              }}
              trigger={["hover", "focus"]}
              placement="bottom-start"
              overlay={<AdditionalInfo shoe={this.props} />}
            >
              <div style={{ cursor: "pointer", fontSize: 20 }}>
                {this.getRatingText(rating)}
              </div>
            </OverlayTrigger>
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-evenly",
                paddingLeft: 10,
              }}
            >
              {/*<OverlayTrigger
                  popperConfig={{modifiers:[
                    {
                      name: 'offset',
                      options: {
                        offset: [-5, 10]
                      }
                    }]
                  }}
                  trigger={["hover","focus"]}
                  placement="bottom-start"
                  overlay={<CriticInfo critic_id={this.props.critic_id}/>}> */}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Link
                  style={{
                    fontSize: 18,
                    lineHeight: 1.2,
                    color: "black",
                    fontWeight: 600,
                  }}
                  to={{
                    pathname:
                      this.props?.by === "user"
                        ? "/shoe-reviews/user/"
                        : "/shoe-reviews/critic/",
                    search: queryString.stringify({
                      id:
                        this.props?.by === "user"
                          ? this.props.enduser_id
                          : this.props.critic_id,
                    }),
                  }}
                >
                  {this.props?.by === "user"
                    ? this.props.enduser_name
                    : this.props.name}
                </Link>
              </div>
              {/*  </OverlayTrigger> */}
              <div style={{ fontSize: 12 }}>
                {Helper.getDateString(this.props.date)}
              </div>
            </div>
          </div>
          {this.props.picture_url && (
            <div>
              <picture>
                <source
                  type="image/webp"
                  data-srcset={Helper.create_source_set(
                    { master: this.props.picture_url, thumbnails: "1" },
                    undefined,
                    "webp"
                  )}
                  sizes={"143px"}
                />
                <source
                  type="image/png"
                  data-srcset={Helper.create_source_set(
                    { master: this.props.picture_url, thumbnails: "1" },
                    undefined,
                    "png"
                  )}
                  sizes={"143px"}
                />
                <img
                  onClick={() => this.props.openStylePopup(this.props.style_id)}
                  alt={this.props.shoe_name}
                  style={{
                    cursor: "pointer",
                    height: 80,
                    marginTop: 5,
                    marginBottom: 10,
                    transform:
                      this.props.picture_mirror == "1" ? "scaleX(-1)" : "",
                  }}
                  className="lazyload"
                  sizes={"143px"}
                  data-srcset={Helper.create_source_set({
                    master: this.props.picture_url,
                    thumbnails: "1",
                  })}
                />
              </picture>
            </div>
          )}
          <div style={{ fontSize: 16 }}>
            {summary === "" ? (
              <div
                style={{
                  fontStyle: "italic",
                  color: "#666",
                  fontSize: 14,
                  marginTop: -5,
                }}
              >
                User didn't add a summary.
              </div>
            ) : (
              summary
            )}
            {this.props.by !== "user" ? (
              <div style={{ marginTop: 10 }}>
                <span
                  onClick={(x) => this.props.pickReview()}
                  style={{
                    fontSize: 16,
                    cursor: "pointer",
                    fontWeight: "bold",
                    lineHeight: 1.2,
                  }}
                >
                  <i className="far fa-plus-square"></i>&nbsp;More details
                </span>
                {/*this.getLinks()*/}
              </div>
            ) : (
              <div style={{ marginTop: 10 }}>
                <span
                  onClick={(x) => this.props.pickReview()}
                  style={{
                    fontSize: 16,
                    cursor: "pointer",
                    fontWeight: "bold",
                    lineHeight: 1.2,
                  }}
                >
                  <i className="far fa-plus-square"></i>&nbsp;More details
                </span>
                {/*this.getLinks()*/}
              </div>
            )}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}
